import { Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useDialogStore } from "dialogs"
import useKeyDown from "utils/use-key-down"

type Props = {
  title?: string,
  content?: React.ReactNode,
  onConfirm?: () => void | boolean
}

const ConfirmDeleteDialog = ({ title, content, onConfirm }: Props) => {

  const dialog = useDialogStore()

  const apply = () => {
    if (!onConfirm) return false
    const res = onConfirm()
    if (res === false) return false
    
    dialog.close()
    return true
  }

  useKeyDown({
    "Enter": () => {
      return apply()
    }
  })

  return (
    <>
      <DialogTitle sx={{ pb: 1 }}>{title || "Вы уверены?"}</DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Typography color="text.secondary" fontSize={12} whiteSpace="pre">
          { content || "" }
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3 }}>
        <Button sx={{ width: 140 }} variant="contained" onClick={() => dialog.close()}>Отмена</Button>
        <Button sx={{ width: 140 }} variant="contained" color="secondary" onClick={apply}>Удалить</Button>
      </DialogActions>
    </> 
  )

}

export default ConfirmDeleteDialog